import React from 'react';
import { TCreateUserSelectedItem } from '../../../../../createUserState/createUserContext';
import { IItemForGetShortInfo, UserRoles } from 'types';
import CustomerSelect from './CustomerSelect';
import { CustomersMultipleSelect } from './CustomersMultipleSelect';
import RestaurantsMultipleSelect from './RestaurantsMultipleSelect/RestaurantsMultipleSelect';

interface IAdditionalFields {
	roleName: string;
	selectedCustomer: TCreateUserSelectedItem;
	selectedCustomers: string[];
	selectedRestaurants: string[];
	setCustomer: (value: TCreateUserSelectedItem) => void;
	setCustomers: (value: string[]) => void;
	setFetchedCustomers: (value: IItemForGetShortInfo[]) => void;
	setRestaurants: (value: string[]) => void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

const AdditionalFields: React.FC<IAdditionalFields> = ({
	roleName,
	selectedCustomer,
	selectedCustomers,
	selectedRestaurants,
	setCustomer,
	setCustomers,
	setFetchedCustomers,
	setRestaurants,
	setFetchedRestaurants,
}) => {
	switch (roleName) {
		case UserRoles.CLIENT_MANAGER:
			return (
				<CustomerSelect
					setCustomer={setCustomer}
					setFetchedCustomers={setFetchedCustomers}
					selectedCustomer={selectedCustomer}
				/>
			);
		case UserRoles.GROUP_MANAGER:
			return (
				<CustomersMultipleSelect
					setIDsCustomer={setCustomers}
					setFetchedCustomers={setFetchedCustomers}
					IDsSelectedCustomer={selectedCustomers}
				/>
			);
		case UserRoles.RESTAURANT_MANAGER:
			return (
				<>
					<CustomerSelect
						setCustomer={setCustomer}
						setFetchedCustomers={setFetchedCustomers}
						selectedCustomer={selectedCustomer}
					/>
					<RestaurantsMultipleSelect
						selectedRestaurants={selectedRestaurants}
						selectedCustomer={selectedCustomer}
						setRestaurants={setRestaurants}
						setFetchedRestaurants={setFetchedRestaurants}
					/>
				</>
			);
		default:
			return null;
	}
};

export default React.memo(AdditionalFields);
